import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const OrdersService = Services.orders;
const OrdersTypes = VuexTypes.orders;
export default {
  [OrdersTypes.ORDERS_LIST]: ({ commit, state }, params) => {
    state.ordersList['status'] = statuses.LOADING;
    OrdersService.list(params).then((data) => {
      commit(OrdersTypes.ORDERS_LIST, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDERS_LIST, errResponse);
    });
  },
  [OrdersTypes.ORDERS_LIST_FILTERS]: ({ commit, state }) => {
    state.ordersListFilters['status'] = statuses.LOADING;
    OrdersService.listFilters().then((data) => {
      commit(OrdersTypes.ORDERS_LIST_FILTERS, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDERS_LIST_FILTERS, errResponse);
    });
  },
  [OrdersTypes.ORDERS_CLASSIFIERS]: ({ commit, state }) => {
    state.ordersClassifiers['status'] = statuses.LOADING;
    OrdersService.classifiers().then((data) => {
      commit(OrdersTypes.ORDERS_CLASSIFIERS, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDERS_CLASSIFIERS, errResponse);
    });
  },
  [OrdersTypes.ORDER_UPDATE_DATA]: ({ commit, state }, id) => {
    state.orderUpdateData['status'] = statuses.LOADING;
    OrdersService.editData(id).then((data) => {
      commit(OrdersTypes.ORDER_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_UPDATE_DATA, errResponse);
    });
  },
  [OrdersTypes.ORDER_UPDATE]: ({ commit, state }, { id, update }) => {
    state.orderUpdate['status'] = statuses.LOADING;
    OrdersService.update(id, update).then((data) => {
      commit(OrdersTypes.ORDER_UPDATE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_UPDATE, errResponse);
    });
  },
  [OrdersTypes.ORDER_CREATE]: ({ commit, state }, createData) => {
    state.orderCreate['status'] = statuses.LOADING;
    OrdersService.create(createData).then((data) => {
      commit(OrdersTypes.ORDER_CREATE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_CREATE, errResponse);
    });
  },
  [OrdersTypes.ORDER_APPROVAL]: ({ commit, state }, { orderId, approvalData }) => {
    state.orderApproval['status'] = statuses.LOADING;
    OrdersService.makeApproval(orderId, approvalData).then((data) => {
      commit(OrdersTypes.ORDER_APPROVAL, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_APPROVAL, errResponse);
    });
  },
  [OrdersTypes.ORDER_DELETE]: ({ commit, state }, orderId) => {
    state.orderDelete['status'] = statuses.LOADING;
    OrdersService.deleteOrder(orderId).then((data) => {
      commit(OrdersTypes.ORDER_DELETE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_DELETE, errResponse);
    });
  },
  [OrdersTypes.ORDER_COPY]: ({ commit, state }, orderId) => {
    state.orderCopy['status'] = statuses.LOADING;
    OrdersService.orderCopy(orderId).then((data) => {
      commit(OrdersTypes.ORDER_COPY, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_COPY, errResponse);
    });
  },
  [OrdersTypes.ORDER_ATTACHMENTS]: ({ commit, state }, orderId) => {
    state.orderAttachments['status'] = statuses.LOADING;
    OrdersService.attachments(orderId).then((data) => {
      commit(OrdersTypes.ORDER_ATTACHMENTS, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ATTACHMENTS, errResponse);
    });
  },
  [OrdersTypes.ORDER_UPDATE_ATTACHMENTS_STATUS]: ({ commit, state }, { orderId, updateData }) => {
    state.orderUpdateAttachmentsStatus['status'] = statuses.LOADING;
    OrdersService.updateAttachmentsStatus(orderId, updateData).then((data) => {
      commit(OrdersTypes.ORDER_UPDATE_ATTACHMENTS_STATUS, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_UPDATE_ATTACHMENTS_STATUS, errResponse);
    });
  },
  [OrdersTypes.ORDER_ADD_COMMENT_TO_ATTACHMENT]: ({ commit, state }, { orderId, attachmentId, comment }) => {
    state.orderAddCommentToAttachment['status'] = statuses.LOADING;
    OrdersService.addCommentToAttachment(orderId, attachmentId, comment).then((data) => {
      commit(OrdersTypes.ORDER_ADD_COMMENT_TO_ATTACHMENT, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ADD_COMMENT_TO_ATTACHMENT, errResponse);
    });
  },
  [OrdersTypes.ORDER_DELETE_ATTACHMENT]: ({ commit, state }, { orderId, attachmentId }) => {
    state.orderDeleteAttachment['status'] = statuses.LOADING;
    OrdersService.deleteAttachment(orderId, attachmentId).then((data) => {
      commit(OrdersTypes.ORDER_DELETE_ATTACHMENT, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_DELETE_ATTACHMENT, errResponse);
    });
  },
  [OrdersTypes.ORDER_ACTIVITY]: ({ commit, state }, { id, page }) => {
    state.orderActivity['status'] = statuses.LOADING;
    OrdersService.activity(id, page).then((data) => {
      commit(OrdersTypes.ORDER_ACTIVITY, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ACTIVITY, errResponse);
    });
  },
  [OrdersTypes.ORDER_ITEMS]: ({ commit, state }, orderId) => {
    state.orderItems['status'] = statuses.LOADING;
    OrdersService.items(orderId).then((data) => {
      commit(OrdersTypes.ORDER_ITEMS, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ITEMS, errResponse);
    });
  },
  [OrdersTypes.ORDER_CREATE_ITEM]: ({ commit, state }, { orderId, createData }) => {
    state.orderCreateItem['status'] = statuses.LOADING;
    OrdersService.createItem(orderId, createData).then((data) => {
      commit(OrdersTypes.ORDER_CREATE_ITEM, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_CREATE_ITEM, errResponse);
    });
  },
  [OrdersTypes.ORDER_UPDATE_ITEM]: ({ commit, state }, { orderId, itemId, updateData }) => {
    state.orderUpdateItem['status'] = statuses.LOADING;
    OrdersService.updateItem(orderId, itemId, updateData).then((data) => {
      commit(OrdersTypes.ORDER_UPDATE_ITEM, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_UPDATE_ITEM, errResponse);
    });
  },
  [OrdersTypes.ORDER_DELETE_ITEM]: ({ commit, state }, { orderId, itemId }) => {
    state.orderDeleteItem['status'] = statuses.LOADING;
    OrdersService.deleteItem(orderId, itemId).then((data) => {
      commit(OrdersTypes.ORDER_DELETE_ITEM, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_DELETE_ITEM, errResponse);
    });
  },
  [OrdersTypes.ORDER_FACTS_AND_INVOICES_LIST]: ({ commit, state }, reqData) => {
    state.orderFactsAndInvoicesList['status'] = statuses.LOADING;
    OrdersService.factsAndInvoicesList(reqData).then((data) => {
      commit(OrdersTypes.ORDER_FACTS_AND_INVOICES_LIST, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_FACTS_AND_INVOICES_LIST, errResponse);
    });
  },
  [OrdersTypes.ORDER_UPDATE_FACT]: ({ commit, state }, { orderId, itemId, updateData }) => {
    state.orderUpdateFact['status'] = statuses.LOADING;
    OrdersService.updateFact(orderId, itemId, updateData).then((data) => {
      commit(OrdersTypes.ORDER_UPDATE_FACT, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_UPDATE_FACT, errResponse);
    });
  },
  [OrdersTypes.ORDER_APPROVE_FACT_AND_INVOICE]: ({ commit, state }, { orderId, approveData }) => {
    state.orderApproveFactAndInvoice['status'] = statuses.LOADING;
    OrdersService.approveFactAndInvoice(orderId, approveData).then((data) => {
      commit(OrdersTypes.ORDER_APPROVE_FACT_AND_INVOICE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_APPROVE_FACT_AND_INVOICE, errResponse);
    });
  },
  [OrdersTypes.ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER]: ({ commit, state }, { orderId, invoiceId, sendData }) => {
    state.orderItemsSendInvoiceToBookkeeper['status'] = statuses.LOADING;
    OrdersService.itemSendToBookkeeper(orderId, invoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER, errResponse);
    });
  },
  [OrdersTypes.ORDER_ITEMS_APPROVE_INVOICE_REVIEW]: ({ commit, state }, { orderId, invoiceId, sendData }) => {
    state.orderItemsSendInvoiceToBookkeeper['status'] = statuses.LOADING;
    OrdersService.itemApproveReview(orderId, invoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_ITEMS_APPROVE_INVOICE_REVIEW, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ITEMS_APPROVE_INVOICE_REVIEW, errResponse);
    });
  },
  [OrdersTypes.ORDER_ITEMS_DECLINE_INVOICE_REVIEW]: ({ commit, state }, { orderId, invoiceId, sendData }) => {
    state.orderItemsSendInvoiceToBookkeeper['status'] = statuses.LOADING;
    OrdersService.itemDeclineReview(orderId, invoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_ITEMS_DECLINE_INVOICE_REVIEW, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_ITEMS_DECLINE_INVOICE_REVIEW, errResponse);
    });
  },
  [OrdersTypes.ORDER_INVOICES_ADVANCE_LIST]: ({ commit, state }, reqData) => {
    state.orderInvoicesAdvanceList['status'] = statuses.LOADING;
    OrdersService.invoicesAdvanceList(reqData).then((data) => {
      commit(OrdersTypes.ORDER_INVOICES_ADVANCE_LIST, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_INVOICES_ADVANCE_LIST, errResponse);
    });
  },
  [OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE]: ({ commit, state }, { orderId, advanceInvoiceId }) => {
    state.orderApproveInvoiceAdvance['status'] = statuses.LOADING;
    OrdersService.approveInvoiceAdvance(orderId, advanceInvoiceId).then((data) => {
      commit(OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE, errResponse);
    });
  },
  [OrdersTypes.ORDER_REMOVE_INVOICE_ADVANCE]: ({ commit, state }, { orderId, advanceInvoiceId }) => {
    state.orderRemoveInvoiceAdvance['status'] = statuses.LOADING;
    OrdersService.removeInvoiceAdvance(orderId, advanceInvoiceId).then((data) => {
      commit(OrdersTypes.ORDER_REMOVE_INVOICE_ADVANCE, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_REMOVE_INVOICE_ADVANCE, errResponse);
    });
  },
  [OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE_REVIEW]: ({ commit, state }, { orderId, advanceInvoiceId, sendData }) => {
    state.orderApproveInvoiceAdvanceReview['status'] = statuses.LOADING;
    OrdersService.approveInvoiceAdvanceReview(orderId, advanceInvoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE_REVIEW, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE_REVIEW, errResponse);
    });
  },
  [OrdersTypes.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW]: ({ commit, state }, { orderId, advanceInvoiceId, sendData }) => {
    state.orderDeclineInvoiceAdvanceReview['status'] = statuses.LOADING;
    OrdersService.declineInvoiceAdvanceReview(orderId, advanceInvoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW, errResponse);
    });
  },
  [OrdersTypes.ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER]: ({ commit, state }, { orderId, advanceInvoiceId, sendData }) => {
    state.orderSendInvoiceAdvanceToBookkeeper['status'] = statuses.LOADING;
    OrdersService.invoiceAdvanceSendToBookkeeper(orderId, advanceInvoiceId, sendData).then((data) => {
      commit(OrdersTypes.ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER, data);
    }).catch((errResponse) => {
      commit(OrdersTypes.ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER, errResponse);
    });
  },
};
